import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { routes } from './app.routes';
import {
  HTTP_INTERCEPTORS,
  HttpStatusCode,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AuthService } from '@shared/services/auth.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BaseInterceptor } from '@shared/interceptor/base.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { RoleGuard } from '@shared/guards/role-access.guard';

import { TimepickerConfig } from 'ngx-bootstrap/timepicker';

export function getTimepickerConfig(): TimepickerConfig {
  const c = new TimepickerConfig();
  c.showMeridian = false;
  c.meridians = ['午前', '午後'];
  return c;
}

const initApp = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const response = await authService.getProfileAPI();
  const url = window.location.pathname;

  if (response.statusCode === HttpStatusCode.Ok) {
    if (url === '/login') {
      router.navigateByUrl('/');
    }
  } else if (response.statusCode === HttpStatusCode.Unauthorized) {
    router.navigateByUrl('/login');
  }

  const loaderInit = document.getElementById('main-loader');
  if (loaderInit) {
    loaderInit.style.display = 'none';
  }
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAppInitializer(initApp),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom([
      BrowserAnimationsModule,
      TranslateModule.forRoot(),
      ModalModule.forRoot(),
      ToastrModule.forRoot({
        timeOut: 3000,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
      }),
    ]),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BaseInterceptor,
      multi: true,
    },
    { provide: TimepickerConfig, useFactory: getTimepickerConfig },
    RoleGuard,
  ],
};
